<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog" :size="'sh'" :ariaLabel="$t('app.ai_mode')" :closable="!showClientDropdown" :footerActive="false">
    <template slot="header" v-if="false">
      <div class="h-16 bg-secondary dark:bg-darkblue-600 flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <base-icon name="chatbot"/>
          <h2 class="font-bold ml-2">{{$t('ia.title')}}</h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="chat-dialog-content bg-primary-50 w-full h-full dark:bg-darkblue-800 dark:text-darkblue-200">
        <AIChatComponent ref="chat" :disable-input="requireClientId && !idCliente" :custom-buttons="clientButtons" :additional-body-props="additionalBodyProps" auxiliaryStyle=".input-button-container { z-index: unset !important; } .input-button-svg-text>div { margin-right: 1em; }" endpoint="api/agent" demo-role="ai-mode" @render="updateClientButtonLabel" :text-input-styles-values="textInputStylesValues" />
        <base-drop-down
        ref="options"
            v-outside:click="{ exclude: ['options'], handler: closeClientDropdown }"
            :is-open="showClientDropdown"
            custom-class="client-dropdown"
            :custom-style="clientDropdownStyle"
            position="top-left"
            @toggle="closeClientDropdown"
          >
            <el-input
              ref="clientFilterInput"
              v-model="clientFilter"
              class="client-dropdown-filter"
              size="small"
              clearable
              prefix-icon="el-icon-search"
              placeholder="Buscar cliente"
              aria-label="Buscar cliente"
            />
            <div class="client-dropdown-list">
              <base-button
                v-for="client in filteredClients"
                :key="client.idCliente"
                class="client-dropdown-option"
                :class="{ 'is-selected': client.idCliente === idCliente }"
                :aria-pressed="client.idCliente === idCliente"
                :title="client.Nombre"
                mode="secondary-phantom-blue"
                @click="selectClient(client)"
              >
                <span class="client-dropdown-option-content">
                  <span class="client-dropdown-option-label">{{ client.Nombre }}</span>
                  <base-icon v-if="client.idCliente === idCliente" name="check" size="sm" aria-hidden />
                </span>
              </base-button>
              <div v-if="!filteredClients.length" class="client-dropdown-empty">
                {{ clientFilter ? $t('app.no_match_text') : $t('app.no_data_text') }}
              </div>
            </div>
        </base-drop-down>
        <div class="fixed right-1 top-1 z-chatbot">
          <div class="pl-4 py-2 md:py-1">
            <span class="cursor-pointer" @click="toggleDialog">
              <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
            </span>
          </div>
        </div>
      </div>
    </template>
    <template slot="footer">
      <div v-if="showClientDropdown" class="client-dropdown-overlay" @click="closeClientDropdown"></div>
    </template>
  </base-dialog-button>
</template>
<script>
import { i18n } from '@/i18n'
import Roles from '@/config/roles'
import AIChatComponent from '@/components/ia/AIChatComponent.vue'
import colorsMixin from '@/mixins/colorsMixin'

import { getClients } from '@/services/clients/getClients.js'

export default {
  name: 'chat-dialog',
  components: {
    AIChatComponent,
  },
  mixins: [colorsMixin],
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isOpen: this.dialogOpen,
      idCliente: '',
      clientOptions: [],
      clientFilter: '',
      showClientDropdown: false,
      Roles,
      textInputStylesValues: {
        styles: {
          text: { color: 'black' },
          container: { maxHeight: '50px', width: '45%', backgroundColor: 'var(--darkblue-50)', border: '2px solid var(--secondary-500)' },
          focus: { border: '2px solid var(--secondary-900)' },
        },
        placeholder: { text: i18n.t('ia.placeholder'), style: { color: 'var(--secondary-DEFAULT)' } },
        characterLimit: 300,
      }
    }
  },
  computed: {  
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
    role () {
      return this.$store.getters['auth/role']
    },
    darkMode () {
      return this.$store.getters['app/darkMode']
    },
    iaClientFilter: function () {
      return this.$store.getters['app/idClienteFilterIAMenu']?.idCliente
    },
    requireClientId () {
      return [Roles.AdminDistribuidor, Roles.SuperAdminDistribuidor, Roles.SuperAdministrador].includes(this.role)
    },
    additionalBodyProps () {
      return { idCliente: this.requireClientId ? this.idCliente : null }
    },
    clientButtonLabel () {
      const selectedClient = this.clientOptions.find(client => client.idCliente === this.idCliente)
      return selectedClient ? selectedClient.Nombre : i18n.t('app.select_entity_placeholder', { entity: i18n.t('clients.entity_name').toLowerCase() })
    },
    clientSelectorIcon: function () {
      return '<?xml version="1.0" ?> <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"><g fill-rule="evenodd"><path d="M12,15.5 C11.7749021,15.5 11.5595221,15.4087935 11.4035221,15.2471747 L6.23113212,9.894403 C5.91417212,9.566636 5.92451212,9.0451325 6.25410212,8.7299244 C6.58348212,8.4147164 7.10734212,8.4248047 7.42409212,8.7527775 L12,13.4883098 L16.5759121,8.7527775 C16.8924621,8.4250106 17.4163221,8.4147164 17.7459021,8.7299244 C18.0754921,9.0451325 18.0858321,9.566636 17.7688721,9.894403 L12.5964821,15.2471747 C12.4404821,15.4087935 12.2251021,15.5 12,15.5" fill="currentColor"></path></g></svg>'
    },
    clientButtons () {
      if (!this.requireClientId) return []
      const textStyles = { 
        default: { color: this.darkMode ? 'var(--darkblue-100)' : 'var(--secondary-DEFAULT)', filter: 'unset !important' },
        hover: { color: 'white', filter: 'unset !important' } 
      }
      const buttonStyles = {
        svg: {
          content: this.clientSelectorIcon,
          styles: {
            default: { ...textStyles.default, height: 'auto' },
            hover: { ...textStyles.hover, height: 'auto' }
          }
        },
        text: {
          content: i18n.t('app.select_entity_placeholder', { entity: i18n.t('clients.entity_name').toLowerCase() }),
          styles: textStyles
        },
        container: {
          default: { zIndex: '41', backgroundColor: this.darkMode ? 'var(--darkblue-600)' : 'var(--secondary-100)' },
          hover: { zIndex: '41', backgroundColor: this.darkMode ? 'var(--primary-600)' : 'var(--primary-800)' },
          click: { zIndex: '41', backgroundColor: this.darkMode ? 'var(--primary-600)' : 'var(--primary-800)' }
        },
      }
      return [{
        position: 'outside-left',
        initialState: 'default',
        styles: {
          button: {
            default: buttonStyles,
            active: {
              ...buttonStyles,
              svg: {
                ...buttonStyles.svg,
                styles: {
                  default: { ...buttonStyles.svg.styles.default, transform: 'rotate(180deg)' },
                  hover: { ...buttonStyles.svg.styles.hover, transform: 'rotate(180deg)' }
                }
              }
            }
          }
        },
        onClick: () => {
          this.showClientDropdown = !this.showClientDropdown
          if (this.showClientDropdown) {
            this.$nextTick(() => this.$refs.clientFilterInput.focus())
          } else {
            this.clientFilter = ''
          }
          return this.showClientDropdown ? 'active' : 'default'
        }
      }]
    },
    filteredClients () {
      const query = this.clientFilter.trim().toLocaleLowerCase()
      if (!query) return this.clientOptions
      return this.clientOptions.filter(client => (client.Nombre || '').toLocaleLowerCase().includes(query))
    },
    clientDropdownStyle () {
      return {
        top: 'auto',
        bottom: '3.5rem',
        left: '0.75rem',
        width: 'min(24rem, calc(100% - 1.5rem))',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        padding: '0.5rem',
        backgroundColor: 'var(--secondary-50)',
        borderColor: 'var(--secondary-200)'
      }
    }
  },
  watch: {
    clientButtonLabel () {
      this.$nextTick(this.updateClientButtonLabel)
    },
    showClientDropdown (isOpen) {
      const button = this.clientButtons[0]
      if (button && button.setState) {
        button.setState(isOpen ? 'active' : 'default')
      }
      this.$nextTick(this.updateClientButtonLabel)
    },
    async dialogOpen (value, oldValue) {
      if (value !== oldValue) {
        if (value && this.requireClientId) {
          this.clientOptions = await this.getClientes()
          this.idCliente = this.iaClientFilter || ''
        } else {
          this.clientOptions = []
        }
      }
    }
  },
  methods: {
    updateClientButtonLabel () {
      const chat = this.$refs.chat && this.$refs.chat.$el.querySelector('deep-chat')
      if (!chat || !chat.shadowRoot) return
      const label = chat.shadowRoot.querySelector('.custom-button .text-button')
      if (label && label.textContent !== this.clientButtonLabel) {
        label.textContent = this.clientButtonLabel
      }
    },
    closeClientDropdown () {
      this.showClientDropdown = false
      this.clientFilter = ''
    },
    selectClient (client) {
      this.idCliente = this.idCliente === client.idCliente ? null : client.idCliente
      this.closeClientDropdown()
    },
    toggleDialog: function () {
      this.closeClientDropdown()
      this.isOpen = !this.isOpen
      this.$emit('toggleDialog')
    },
    getClientes: async function () {
      const response = await getClients()
      if (response.blnError) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        return []
      }
      return response.Clientes || []
    }
  },
}
</script>
<style scoped>
.chat-dialog-content {
  position: relative;
}

.client-dropdown-filter {
  flex: none;
  margin-bottom: 0.5rem;
}

.client-dropdown-list {
  flex: 0 1 auto;
  max-height: min(50vh, 18rem);
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
}

.client-dropdown-option {
  width: 100%;
  padding: 0.5rem 0.75rem;
  overflow: hidden;
  border: 0;
  border-bottom: 1px solid var(--secondary-100);
}

.client-dropdown-option-content {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  text-align: left;
}

.client-dropdown-option-label {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* .client-dropdown-option:hover,
.client-dropdown-option:focus-visible {
  background: var(--secondary-100);
  color: var(--primary-800);
  outline: none;
}

.client-dropdown-option.is-selected {
  background: var(--primary-800);
  color: #ffffff;
}

.client-dropdown-option.is-selected:hover,
.client-dropdown-option.is-selected:focus-visible {
  background: var(--primary-900);
  color: #ffffff;
} */

.client-dropdown-empty {
  padding: 0.75rem;
  color: var(--secondary-800);
  text-align: center;
}

::v-deep .container.container-width-fs {
  margin: 1rem;
  max-width: none;
}
.client-dropdown-overlay {
  position: fixed;
  inset: 0;
  z-index: 40;
  overflow: hidden;
}
</style>
